import {
    Autocomplete,
    Box,
    Button,
    TextField
} from '@mui/material';
import { FC, useEffect, useState } from 'react';

import { axiosInstance } from '../../services/axios';
import { API_SLUGS } from '../../constants';
import { useHistory } from 'react-router-dom';
import { IAlertState, useAlertState } from '../../store/alertState';

const LinkProjectToJira: FC<any> = ({ projectId, preventRedirect = false }) => {
    const [jiraProjects, setJiraProjects] = useState<any[]>([]);
    const [jiraServers, setJiraServers] = useState<any[]>([]);
    const [selectedJiraProject, setSelectedJiraProject] = useState<any>();
    const [selectedJiraServer, setSelectedJiraServer] = useState<any>();
    const [selectedJiraDetails, setSelectedJiraDetails] = useState<any>();
    const { setMessage } = useAlertState() as IAlertState;

     const navigate = useHistory();

    useEffect(() => {
        getJiraServers();
        getLinkedJiraDetails();
    }, []);

    useEffect(() => {
        setSelectedJiraProject(undefined);
        if (selectedJiraServer?.uuid) {
            getJiraProjects();
        }
    }, [selectedJiraServer]);

    useEffect(() => {
        if (selectedJiraDetails && jiraServers.length > 0) {
            const server = jiraServers.find(
                (s: any) => s?.uuid === selectedJiraDetails?.serverId
            );
            if (server) {
                setSelectedJiraServer(server);
                fetchLinkedJiraProject(server.uuid);
            }
        }
    }, [selectedJiraDetails, jiraServers]);

    const getJiraServers = async () => {
        try {
            const resp = await axiosInstance.get(API_SLUGS.CLOUD_INTEGRATION);
            setJiraServers(resp?.data?.jira?.servers || []);
        } catch (error) {

        }
    };

    const getJiraProjects = async () => {
        try {
            const path = API_SLUGS.JIRA_PROJECTS + `?serverId=${selectedJiraServer?.uuid}`;
            const resp = await axiosInstance.get(path);
            setJiraProjects(resp?.data || []);
        } catch (error) {

        }
    };

    const fetchLinkedJiraProject = async (serverId: string) => {
        try {
            const path = API_SLUGS.JIRA_PROJECTS + `?serverId=${serverId}`;
            const resp = await axiosInstance.get(path);
            setJiraProjects(resp?.data || []);

            const project = resp?.data?.find(
                (proj: any) => proj?.id === selectedJiraDetails?.projectId
            );
            if (project) {
                setSelectedJiraProject(project);
            }
        } catch (error) {

        }
    };

    const getLinkedJiraDetails = async () => {
        try {
            const path = API_SLUGS.LINK_TO_JIRA.replace("{projectId}", projectId);
            const resp = await axiosInstance.get(path);
            const details = resp?.data?.details;
            setSelectedJiraDetails(details);
        } catch (error) {

        }
    };

    const saveJiraConfig = async () => {
        try {
            const details = {
                serverId: selectedJiraServer?.uuid,
                projectId: selectedJiraProject?.id
            };
            const path = API_SLUGS.LINK_TO_JIRA.replace("{projectId}", projectId);
            await axiosInstance.put(path, { type: "jira", details });
            setMessage({title: "Project linked to Jira Project succesfully", type: "success"})
            if (!preventRedirect) {
                navigate.push(`/projects/${projectId}`);
            }
        } catch (error: any) {
            setMessage({title: error, type: "error"})
        }
    };

    return (
        <Box>
             <Autocomplete
                key={selectedJiraServer?.uuid || 'default-server'}
                sx={{ maxWidth: "20em", textAlign: "left", flex: 1, mr: 2, my: 4 }}
                size="small"
                getOptionLabel={(option: any) => option?.name || ""}
                options={jiraServers || []}
                onChange={(e, value) => setSelectedJiraServer(value)}
                value={selectedJiraServer}
                filterOptions={(options, params) =>
                    options.filter((item: any) =>
                        item?.name?.toLowerCase().includes(params.inputValue.toLowerCase())
                    )
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disableClearable
                renderInput={(params): JSX.Element => (
                    <TextField
                        autoComplete="off"
                        name="id"
                        variant="outlined"
                        label="Cloud Server"
                        {...params}
                    />
                )}
            />
            

            <Autocomplete
                key={selectedJiraProject?.id || 'default-project'}
                sx={{ maxWidth: "20em", textAlign: "left", flex: 1 }}
                size="small"
                getOptionLabel={(option: any) => option?.name || ""}
                options={jiraProjects || []}
                onChange={(e, value) => setSelectedJiraProject(value)}
                value={selectedJiraProject}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, params) =>
                    options.filter((item: any) =>
                        item?.name?.toLowerCase().includes(params.inputValue.toLowerCase()) ||
                        item?.key?.toLowerCase().includes(params.inputValue.toLowerCase())
                    )
                }
                disableClearable
                disabled={!selectedJiraServer}
                renderInput={(params): JSX.Element => (
                    <TextField
                        autoComplete="off"
                        name="id"
                        variant="outlined"
                        label="Cloud Project"
                        {...params}
                    />
                )}
            />

            <Button
                color="primary"
                size="medium"
                variant="contained"
                disabled={!selectedJiraProject || !selectedJiraServer}
                onClick={saveJiraConfig}
                sx={{ mt: 4 }}
            >
                Save
            </Button>
        </Box>
    );
};

export default LinkProjectToJira;
